'use client'

import dynamic from 'next/dynamic'
import { ComponentType } from 'react'

/**
 * Créer un composant lazy avec fallback
 */
export function createLazyComponent<P = {}>(
  importFn: () => Promise<{ default: ComponentType<P> }>,
  fallback?: React.ReactNode
) {
  return dynamic(importFn, {
    loading: () => <>{fallback}</>,
    ssr: false,
  })
}

/**
 * Créer un composant lazy avec SSR
 */
export function createLazyComponentSSR<P = {}>(
  importFn: () => Promise<{ default: ComponentType<P> }>,
  fallback?: React.ReactNode
) {
  return dynamic(importFn, {
    loading: () => <>{fallback}</>,
    ssr: true,
  })
}

/**
 * Skeleton loader simple
 */
export const SkeletonLoader = () => (
  <div className="animate-pulse space-y-4">
    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
    <div className="h-4 bg-gray-200 rounded"></div>
    <div className="h-4 bg-gray-200 rounded w-5/6"></div>
  </div>
)

/**
 * Card skeleton loader
 */
export const CardSkeleton = () => (
  <div className="animate-pulse rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
    <div className="h-6 bg-gray-200 rounded w-2/3 mb-4"></div>
    <div className="space-y-3">
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded w-5/6"></div>
      <div className="h-4 bg-gray-200 rounded w-4/6"></div>
    </div>
  </div>
)
